import { render, staticRenderFns } from "./GoodReturnListView.vue?vue&type=template&id=64b15091"
import script from "./GoodReturnListView.vue?vue&type=script&lang=js"
export * from "./GoodReturnListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports